import React from "react";

export const NotificationContext = React.createContext({
	show: (variant, content) => {}
})
